import { JSX, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  loadInitialAuthenticationStateAsync,
  selectAuthInitializationStatus,
  updateAuthenticationState,
} from "../../features/authentication/authenticationSlice";
import { serializeOidcUser } from "../../features/authentication/serializeUser";
import { User } from "oidc-client";

const InitializeAuth = ({ children }: { children: JSX.Element }) => {
  const initializationStatus = useAppSelector(selectAuthInitializationStatus);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (initializationStatus === "not-initialized") {
      dispatch(loadInitialAuthenticationStateAsync());
    }
  }, [dispatch, initializationStatus]);

  // Listen for silent token refresh events
  useEffect(() => {
    const handleTokenRefreshed = (event: CustomEvent<User>) => {
      const serializedUser = serializeOidcUser(event.detail);
      dispatch(updateAuthenticationState(serializedUser));
    };

    const handleSilentRenewError = (event: CustomEvent) => {
      console.error("❌ Silent renew error, user may need to re-login:", event.detail);
    };

    window.addEventListener("oidc-token-refreshed", handleTokenRefreshed as EventListener);
    window.addEventListener("oidc-silent-renew-error", handleSilentRenewError as EventListener);

    return () => {
      window.removeEventListener("oidc-token-refreshed", handleTokenRefreshed as EventListener);
      window.removeEventListener("oidc-silent-renew-error", handleSilentRenewError as EventListener);
    };
  }, [dispatch]);

  if (initializationStatus === "initialized") {
    return children;
  }

  return <></>;
};
export default InitializeAuth;
